import { render, staticRenderFns } from "./deployment_info.vue?vue&type=template&id=2d98e6ea"
import script from "./deployment_info.vue?vue&type=script&lang=js"
export * from "./deployment_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports